import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import Button from "@/components/Button";
import Input from "@/components/Input";
import { ApiService } from "@/services/ApiService";
import { useTranslation } from "react-i18next";
// @ts-ignore
import { toast } from "sonner";

interface ExpiracaoDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  licencaId: string | null;
  dataExpiracaoAtual: Date | string | null;
  onSuccess: () => void;
}

const ExpiracaoDialog: React.FC<ExpiracaoDialogProps> = ({ open, setOpen, licencaId, dataExpiracaoAtual, onSuccess }) => {
  const { t } = useTranslation();
  const [dataDeExpiracao, setDataDeExpiracao] = useState<string>("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (dataExpiracaoAtual) {
      // Ajusta o fuso horário para popular corretamente o input type="datetime-local"
      const dateObj = new Date(dataExpiracaoAtual);
      const offset = dateObj.getTimezoneOffset() * 60000;
      const localISOTime = (new Date(dateObj.getTime() - offset)).toISOString().slice(0, 16);
      setDataDeExpiracao(localISOTime);
    } else {
      setDataDeExpiracao("");
    }
  }, [dataExpiracaoAtual]);

  const handleSubmit = async () => {
    if (!dataDeExpiracao) {
      toast.error(t("frequenciaDialog.messages.formatError", "Data inválida."));
      return;
    }
    
    setLoading(true);
    try {
      // Usa a mesma rota de atualização passando apenas a nova data
      await ApiService.patch(`api/v1/licenca/atualizar/${licencaId}`, {
        dataDeExpiracao: dataDeExpiracao
      });
      toast.success("Data de expiração atualizada com sucesso!");
      setOpen(false);
      onSuccess(); 
    } catch (error: any) {
      toast.error("Erro ao atualizar a data de expiração.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("expiracaoDialog.title")}</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <Input
            id="dataDeExpiracao"
            type="datetime-local"
            label={t("expiracaoDialog.inputs.dataDeExpiracao.label")}
            value={dataDeExpiracao}
            onChange={(e: any) => setDataDeExpiracao(e.target.value)}
          />
        </div>
        <DialogFooter>
          <Button label={t("frequenciaDialog.buttons.cancel", "Cancelar")} onClick={() => setOpen(false)} color="neutro" />
          <Button label={t("frequenciaDialog.buttons.save", "Salvar")} onClick={handleSubmit} color="primario" disabled={loading} />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ExpiracaoDialog;